import Table, { ColumnsType } from "antd/lib/table"
import { WebApiMemberDtoMemberDto, WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto } from "../../Repository/eventbookyapi"
import { Button, Popconfirm, Space, TableProps } from "antd";
import EditMember from "../Users/EditMember";
import AddNote from "../Users/AddNote";
import AddPayment from "../Users/AddPayment";
import { ArrowDownOutlined, DeleteOutlined } from "@ant-design/icons";
import { formatDateString } from "../../Helpers/DateHelpers";
import { TextService } from "../../Services/TextService";
import { MemberService } from "../../Services/MemberService";
import { ComponentPropsWithoutRef, useEffect, useState } from "react";
import { PaymentConfiguration } from "../../Types/PaymentConfiguration";
import Cookies from "universal-cookie";
import AddPaymentLink from "../Users/AddPaymentLink";
import { SavedSorting } from "../../Types/SavedSorting";
import { SortOrder } from "antd/es/table/interface";
import moment from "moment";

export const MemberTable = (props: any) => {

    const GetText = TextService.GetText;
    const [memberToDelete, setMemberToDelete] = useState(0 as number);
    const [sortedInfo, setSortedInfo] = useState(undefined as SavedSorting | undefined);

    useEffect(() => {
        if (props.savedSorting) {
            setSortedInfo(props.savedSorting);
        };

    }, [props])


    const sortAlphabeticly = (function (a: any, b: any, propName: string) {
        const itemAProp = a[propName] != null && a[propName] != undefined ? a[propName].toString().toLowerCase() : "";
        const itemBProp = b[propName] != null && b[propName] != undefined ? b[propName].toString().toLowerCase() : "";
        return itemAProp.localeCompare(itemBProp, 'sv');
    })

    const sortDate = (a: Date | undefined, b: Date | undefined) => {
        if (!a && !b) return 0;
        if (!a) return -1;
        if (!b) return 1;
        return moment(a).diff(moment(b));
    };

    const sortUniqueId = (function (a: any, b: any) {
        if (Number(a.uniqueId) < Number(b.uniqueId)) { return -1; }
        if (Number(a.uniqueId) > Number(b.uniqueId)) { return 1; }
        return 0;
    })

    const onDeleteClick = (memberId: number) => {
        setMemberToDelete(memberId);
    };

    const handleOk = async () => {
        await MemberService.DeleteMember(memberToDelete);
        props.loadMembers();
        setMemberToDelete(0);
    };

    const onPaginateChange = (value: any, newPageSize: any) => {
        new Cookies().set('customerPageSize', newPageSize, { maxAge: 31536000 });
        props.handlePageSizeChanged(newPageSize);
    };


    const onTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
        if (sorter != null && sorter.field != null) {
            const cookies = new Cookies();
            const sorting: SavedSorting = { columnKey: sorter.field, sortingDirection: sorter.order };
            cookies.set('customerSorter', JSON.stringify(sorting), { maxAge: 31536000 });
            setSortedInfo({ columnKey: sorter.field.toLowerCase(), sortingDirection: sorter.order });
        }
    }
    const sortIconClassName = 'ant-table-column-title';
    const HeaderCell = (props: ComponentPropsWithoutRef<'th'>) => {
        return (
            <th
                {...props}
                onClick={(e) => {
                    const currentTarget = e.currentTarget as HTMLElement;
                    const sortIconNode = currentTarget.querySelector(`.${sortIconClassName}`);
                    if (sortIconNode?.contains(e.target as HTMLElement)) {
                        props.onClick?.(e);
                    }
                }}
            />
        );
    };

    const components: TableProps['components'] = {
        header: {
            cell: HeaderCell
        }
    };


    const columns: ColumnsType<WebApiMemberDtoMemberDto> = [
        {
            title: GetText("MemberList_UniqueIdColumn"),
            width: 100,
            dataIndex: 'uniqueid',
            sortOrder: sortedInfo?.columnKey === 'uniqueid' ? sortedInfo?.sortingDirection as SortOrder : undefined,
            key: 'uniqueid',
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{member.uniqueId}<br />
                </span>
            ),
            sorter: sortUniqueId,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: GetText("MemberList_FirstNameColumn"),
            dataIndex: 'firstname',
            key: 'firstname',
            sortOrder: sortedInfo?.columnKey === 'firstname' ? sortedInfo?.sortingDirection as SortOrder : undefined,
            width: 150,
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{member.firstName}<br />
                </span>
            ),
            sorter: { compare: (a, b) => sortAlphabeticly(a, b, "firstName"), multiple: 2 },
            sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
            title: GetText("MemberList_LastNameColumn"),
            dataIndex: 'lastname',
            key: 'lastname',
            sortOrder: sortedInfo?.columnKey === 'lastname' ? sortedInfo?.sortingDirection as SortOrder : undefined,
            width: 150,
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{member.lastName}<br />
                </span>
            ),
            sorter: { compare: (a, b) => sortAlphabeticly(a, b, "lastName") },
            sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
            title: GetText("MemberList_EmailColumn"),
            dataIndex: 'email',
            key: 'email',
            sortOrder: sortedInfo?.columnKey === 'email' ? sortedInfo?.sortingDirection as SortOrder : undefined,
            width: 150,
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{member.email}<br />
                </span>
            ),
            sorter: { compare: (a, b) => sortAlphabeticly(a, b, "email") },
            sortDirections: ['ascend', 'descend', 'ascend'],

        },
        {
            title: GetText("MemberList_PhoneColumn"),
            dataIndex: 'phone',
            key: 'phone',
            width: 150,
            sorter: false,
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{member.phoneNumberFormatted}<br />
                </span>
            ),
        },
        {
            title: GetText("MemberList_GroupsColumn"),
            dataIndex: 'company',
            key: 'company',
            width: 150,
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>

                    {member!.groupNames?.map((groupName: any, i) => {
                        return (<>{groupName} <br /></>)
                    })}


                    <br />
                </span>
            ),
        }]

    if (props.isMail == true) {

        columns.push({
            title: GetText("MemberList_ActionColumn"),
            key: 'action',
            render: (_, member) => (
                <Space size="middle">
                    <Button size="small" onClick={() => props.removeMember(member)}>Ta bort</Button>
                </Space>
            )
        })
    }
    else {
        columns.push({
            title: GetText("MemberList_LastModifiedColumn"),
            dataIndex: 'lastmodified',
            key: 'lastmodified',
            sortOrder: sortedInfo?.columnKey === 'lastmodified' ? sortedInfo?.sortingDirection as SortOrder : undefined,
            width: 150,
            sorter: { compare: (a, b) => sortDate(a.lastModified, b.lastModified) },
            render: (_, member: WebApiMemberDtoMemberDto) => (
                <span>{formatDateString(member?.lastModified!.toString())}<br />
                </span>
            ),
        },
            {
                title: GetText("MemberList_CreatedColumn"),
                dataIndex: 'createdat',
                key: 'createdat',
                sortOrder: sortedInfo?.columnKey === 'createdat' ? sortedInfo?.sortingDirection as SortOrder : undefined,
                width: 150,
                sorter: { compare: (a, b) => sortDate(a.createdAt, b.createdAt) },
                render: (_, member: WebApiMemberDtoMemberDto) => (
                    <span>{formatDateString(member?.createdAt!.toString())}<br />
                    </span>
                ),
            },
            {
                title: GetText("MemberList_ActionColumn"),
                key: 'action',
                width: 150,
                render: (_, member) => (
                    <Space size="middle">
                        <EditMember user={props.user} memberFieldSettings={props.memberFieldSettings} loadMembers={props.loadMembers} members={props.members} groups={props.groups} member={member}>Edit</EditMember>
                        <AddNote user={props.user} loadMembers={props.loadMembers} groups={props.groups} member={member}></AddNote>
                        {props.user.paymentConfiguration == PaymentConfiguration.YearlyPayments ? <AddPayment loadMembers={props.loadMembers} groups={props.groups} member={member}></AddPayment> : ""}
                        {props.hasPingPaymentIntegration ? <AddPaymentLink user={props.user} loadMembers={props.loadMembers} groups={props.groups} member={member}></AddPaymentLink> : ""}

                        {!props.user.hasOnlyReadRights ? <DeleteOutlined style={{ color: "red", fontSize: "20px" }} onClick={() => onDeleteClick(member?.memberId!)}></DeleteOutlined> : ""}

                        <Popconfirm
                            title={GetText("MemberList_DeleteMemberConfirmMessage")}
                            key={member.email}
                            open={member.memberId === memberToDelete}
                            placement="topRight"
                            onConfirm={handleOk}
                            onCancel={() => setMemberToDelete(0)}
                        >
                        </Popconfirm>
                    </Space>
                ),
            },)
    }

    return (<Table
        columns={columns}
        style={props.style}
        locale={{ emptyText: GetText("MemberList_EmptyMessage") }}
        className="admin-table"
        rowKey={m => m.memberId!}
        showSorterTooltip={false}
        components={components}
        onChange={onTableChange}
        sortDirections={['ascend', 'descend', 'ascend']}
        pagination={{ pageSize: props.pageSizePreference, locale: { items_per_page: "/ " + GetText("Common_Page") }, position: ['topRight'], showSizeChanger: true, onShowSizeChange: onPaginateChange }}
        dataSource={props.members}
        rowClassName={(record: WebApiMemberDtoMemberDto, index) => record.status == 1 ? "cancelled-member" : ""}
    />);
}